import CitiesFilter from "./CitiesFilter";

export default CitiesFilter;
